export default __webpack_public_path__ + "9edbabc6bdccca123a055c26e75afcbf.woff2";